import CustomApiError from './CustomError';

export default class RoleError extends CustomApiError {
  toDictionary() {
    return {
      ROLE_NOT_FOUND: 'O cliente não foi encontrado.',
    };
  }
}
